import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

export default function BlogPageHero() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 60);
    return () => clearTimeout(t);
  }, []);

  return (
    <section className="relative pt-36 pb-20 bg-zinc-950 overflow-hidden">
      <div className="absolute inset-0 pointer-events-none">
        <div
          className="absolute -top-32 left-1/2 -translate-x-1/2 w-[900px] h-[500px] rounded-full opacity-30"
          style={{ background: 'radial-gradient(ellipse, rgba(249,115,22,0.18) 0%, transparent 65%)' }}
        />
        <div
          className="absolute inset-0 opacity-[0.025]"
          style={{
            backgroundImage:
              'linear-gradient(rgba(249,115,22,0.7) 1px, transparent 1px), linear-gradient(90deg, rgba(249,115,22,0.7) 1px, transparent 1px)',
            backgroundSize: '72px 72px',
          }}
        />
      </div>

      <div className="relative max-w-7xl mx-auto px-6 text-center">
        <div
          className="inline-flex items-center gap-2 bg-orange-500/10 border border-orange-500/20 rounded-full px-4 py-1.5 mb-7"
          style={{ opacity: visible ? 1 : 0, transform: visible ? 'translateY(0)' : 'translateY(10px)', transition: 'all 0.5s ease' }}
        >
          <i className="ri-article-line text-orange-400 text-sm" />
          <span className="text-orange-300 text-sm font-medium">Blog & Aktuality</span>
        </div>

        <h1
          className="text-5xl sm:text-6xl md:text-7xl font-black text-white leading-tight tracking-tight mb-6"
          style={{ opacity: visible ? 1 : 0, transform: visible ? 'translateY(0)' : 'translateY(16px)', transition: 'all 0.6s ease 0.1s' }}
        >
          Novinky zo sveta{' '}
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-orange-400 to-amber-400">
            digitálu
          </span>
        </h1>

        <p
          className="text-zinc-400 text-lg sm:text-xl max-w-2xl mx-auto mb-10"
          style={{ opacity: visible ? 1 : 0, transform: visible ? 'translateY(0)' : 'translateY(12px)', transition: 'all 0.6s ease 0.2s' }}
        >
          Praktické rady, case studies a trendy z praxe - nič teórie, len to čo skutočne funguje.
        </p>

        <div
          className="flex flex-wrap items-center justify-center gap-6 text-zinc-500 text-sm"
          style={{ opacity: visible ? 1 : 0, transition: 'all 0.6s ease 0.3s' }}
        >
          <div className="flex items-center gap-2">
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-file-text-line text-orange-400" />
            </div>
            <span>6 článkov</span>
          </div>
          <div className="w-px h-4 bg-zinc-800" />
          <div className="flex items-center gap-2">
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-user-line text-orange-400" />
            </div>
            <span>Bc. Kamil Frajtko & tím</span>
          </div>
          <div className="w-px h-4 bg-zinc-800" />
          <div className="flex items-center gap-2">
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-time-line text-orange-400" />
            </div>
            <span>Každý týždeň nový článok</span>
          </div>
        </div>

        <div className="mt-12 flex items-center gap-3 max-w-sm mx-auto">
          <Link
            to="/#kontakt"
            className="flex-1 bg-zinc-900 border border-zinc-700/50 rounded-xl px-5 py-3 flex items-center justify-center gap-2 text-zinc-400 hover:text-white hover:border-orange-500/40 transition-all duration-200 text-sm cursor-pointer whitespace-nowrap"
          >
            <i className="ri-notification-line text-orange-400" />
            Newsletter
          </Link>
          <Link
            to="/#kontakt"
            className="flex-1 bg-orange-500 hover:bg-orange-400 rounded-xl px-5 py-3 flex items-center justify-center gap-2 text-white font-semibold transition-all duration-200 text-sm cursor-pointer whitespace-nowrap"
          >
            Konzultácia zadarmo
            <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </div>
    </section>
  );
}
